var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgLarrowpSpark = function SvgLarrowpSpark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "477.313 214.192 11.979 12.266"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M488.813 225.987c-.239.235-.719.471-1.198.471-.958 0-1.677-.707-1.677-1.651v-7.313h-6.948c-.958 0-1.677-.707-1.677-1.65 0-.944.72-1.652 1.677-1.652h8.625c.96 0 1.677.708 1.677 1.651v8.964c0 .472-.239.944-.479 1.18z",
    fill: "#E55C6C"
  })));
};
export default SvgLarrowpSpark;